import { TaskStatuses } from '~/constants/task-status'
import { AgentTaskStatus, agentTaskStatusToJSON } from '~/protos/agents'
import { cm } from '~/utils/utils'
import { getStatusText } from './CampaignTaskBlock'
import styles from './CampaignTaskProgress.module.scss'

interface CampaignTaskProgressBarProps {
  percentage: number
  taskStatus: AgentTaskStatus
  statusText?: boolean
}
export function CampaignTaskProgressBar({
  percentage,
  taskStatus,
  statusText = false
}: CampaignTaskProgressBarProps) {
  return (
    <div className='flex justify-between items-center my-1 w-full'>
      <div
        className={cm(
          `task-progress w-full h-[4px]`,
          'overflow-hidden rounded-full',
          styles.progress
        )}
        style={
          {
            '--bg-color': '#947BFF',
            '--percentage': `${percentage}%`
          } as React.CSSProperties
        }
      ></div>
      <div className='text-default-500 text-xs ml-2 flex flex-nowrap max-w-[40px]'>
        {percentage.toFixed(0)}%{' '}
        {statusText ? getStatusText(agentTaskStatusToJSON(taskStatus)) : ''}
      </div>
    </div>
  )
}
